export enum HttpCodeEnum {
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/http-code.constants.ts